import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";

import { makeStyles } from "@mui/styles";
import {
  AutocompleteInput,
  CustomSelect,
  DateInput,
  CustomSwitch,
  EmailInput,
  IntInput,
  TextInput,
  PasswordInput,
} from "components/Input/Index.js";

import { compte } from "variables/patrimoine.js";
import { statusEnergy, typeAuthorization } from "variables/lists/authorization";
import { billData } from "variables/lists/imports";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CreateButton from "components/CustomButtons/CreateButton.js";
import UserService from "services/UserService";
import { postAPIAuthorization, getFiles } from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function AddAuthorizationDialog(props) {
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [type, setType] = useState("");
  const [energy, setEnergy] = useState("");
  const [metersDso, setMetersDso] = useState("");
  const [apiaccountmail, setApiaccountmail] = useState("");
  const [apisecretkey, setApisecretkey] = useState("");
  const [legalname, setLegalname] = useState("");
  const [datebegin, setDatebegin] = useState("");
  const [dateend, setDateend] = useState("");
  const [ged, setGed] = useState("");
  const [verified, setVerified] = useState("");
  const [comment, setComment] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [postalcode, setPostalcode] = useState("");
  const [ftpdirectory, setFtpdirectory] = useState("");
  const [dsochoruscode, setDsochoruscode] = useState("");
  const [dsofiletemplate, setDsofiletemplate] = useState("");
  const [getAttachedFile, setGetAttachedFile] = useState(false);

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal, refetch, setLoading, setNotification } = props;

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };
  const handleEnergyChange = (e) => {
    setEnergy(e.target.value);
  };
  const handleDsoChange = (e) => {
    setMetersDso(e.target.value);
  };
  const handleApiaccountmailChange = (e) => {
    setApiaccountmail(e.target.value);
  };
  const handleApisecretkeyChange = (e) => {
    setApisecretkey(e.target.value);
  };
  const handleLegalnameChange = (e) => {
    setLegalname(e.target.value);
  };
  const handleDatebeginChange = (e) => {
    setDatebegin(e.target.value);
  };
  const handleDateendChange = (e) => {
    setDateend(e.target.value);
  };
  const handleAssociatedfilesChange = (newValue) => {
    if (newValue)
      setGed(newValue.fileId);
    else
      setGed("");
  };
  const handleVerifiedChange = (e) => {
    setVerified(e.target.value);
  };
  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };
  const handleFirstnameChange = (e) => {
    setFirstname(e.target.value);
  };
  const handleLastnameChange = (e) => {
    setLastname(e.target.value);
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePostalcodeChange = (e) => {
    setPostalcode(e.target.value);
  };
  const handleFtpdirectoryChange = (e) => {
    setFtpdirectory(e.target.value);
  };
  const handleDsochoruscodeChange = (e) => {
    setDsochoruscode(e.target.value);
  };
  const handleDsofiletemplateChange = (e) => {
    setDsofiletemplate(e.target.value);
  };
  const handleGetAttachedFileChange = (event) => { setGetAttachedFile(!getAttachedFile); };
  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (ged !== undefined) {
      gedCardId.push(ged);
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    let selected = {};
    if (getGedNames.length > 0)
      selected = getGedNames[0];
    return selected;
  };

  useEffect(() => {
    let error = false;
    if (!energy || (!metersDso && type !== 'dcx') || !legalname || !datebegin || !dateend
      || !firstname || !lastname || !email || !postalcode) {
      error = true;
    }
    setButtonDisabled(error);
  });

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    if (type) {
      setEnergy(typeAuthorization.find((x) => x.id == type).energy);
      setMetersDso(typeAuthorization.find((x) => x.id == type).dso);
    }
  }, [type]);

  const handleSubmit = (event) => {
    createAuthorization(event);
    setLoading(true);
    closeModal();
  };

  const createAuthorization = async (event) => {
    axios
      .post(
        postAPIAuthorization(chartIdGroup),
        {
          energy,
          dso: metersDso,
          legalname,
          datebegin,
          dateend,
          associatedfile: ged,
          verified,
          comment,
          firstname,
          lastname,
          email,
          postalcode,
          type,
          otherdata: {
            apiaccountmail,
            apisecretkey,
            ftpdirectory,
            dsochoruscode,
            dsofiletemplate,
            getAttachedFile
          }
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Autorisation créée");
          refetch();
        }
        else
          setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        setLoading(false);
      });


  };


  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <CustomSelect
                inputTitle={compte.authorization.type}
                selectValue={type}
                handleSelectValueChange={handleTypeChange}
                data={typeAuthorization}
                isRequired={true}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={compte.authorization.energy}
                selectValue={energy}
                handleSelectValueChange={handleEnergyChange}
                data={statusEnergy}
                isRequired={true}
                disabled={type === 'chorus' ? false : true}
              />
            </div>
            {
              (type !== 'dcx') &&
              <div>
                <TextInput
                  inputTitle={compte.authorization.dso}
                  textInput={metersDso}
                  handleTextInputChange={handleDsoChange}
                  isRequired={true}
                  disabled={type === 'chorus' ? false : true}
                />
              </div>
            }
            {
              (type === 'engiebilleelectricity' || type === 'engiebillegas' || type === 'chorus') &&
              <>
                <div>
                  <TextInput
                    inputTitle={compte.authorization.apiaccountmail}
                    textInput={apiaccountmail}
                    handleTextInputChange={handleApiaccountmailChange}
                  />
                </div>
                <div>
                  <PasswordInput
                    inputTitle={compte.authorization.apisecretkey}
                    textInput={apisecretkey}
                    handleTextInputChange={handleApisecretkeyChange}
                  />
                </div>
              </>
            }
            {
              (type === 'engiebilleelectricity' || type === 'engiebillegas') &&
              <>
                <div>
                  <CustomSwitch
                    inputTitle={compte.authorization.getAttachedFile}
                    checkedState={getAttachedFile}
                    handleSwitchChange={handleGetAttachedFileChange}
                  />
                </div>
              </>
            }
            {
              (type === 'chorus') &&
              <>
                <div>
                  <IntInput
                    inputTitle={compte.authorization.dsochoruscode}
                    intInput={dsochoruscode}
                    handleIntInputChange={handleDsochoruscodeChange}
                    isRequired={true}
                  />
                </div>
                <div>
                  <CustomSelect
                    inputTitle={compte.authorization.dsofiletemplate}
                    selectValue={dsofiletemplate}
                    handleSelectValueChange={handleDsofiletemplateChange}
                    data={billData}
                    isRequired={true}
                  />
                </div>
              </>
            }
            {
              (type === 'gdbftpgas' || type === 'regazftpgas') &&
              <>
                <div>
                  <TextInput
                    inputTitle={compte.authorization.ftpdirectory}
                    textInput={ftpdirectory}
                    handleTextInputChange={handleFtpdirectoryChange}
                  />
                </div>
              </>
            }
            <div>
              <TextInput
                inputTitle={compte.authorization.legalname}
                textInput={legalname}
                handleTextInputChange={handleLegalnameChange}
                isRequired={true}
              />
            </div>
            <div>
              <DateInput
                inputTitle={compte.authorization.datebegin}
                dateInput={datebegin}
                handleDateInputChange={handleDatebeginChange}
                isRequired={true}
              />
            </div>
            <div>
              <DateInput
                inputTitle={compte.authorization.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
                isRequired={true}
              />
            </div>
            <div>
              <AutocompleteInput
                isMultiple={false}
                specialWidth={"97%"}
                inputTitle={compte.authorization.associatedfile}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.authorization.firstname}
                textInput={firstname}
                handleTextInputChange={handleFirstnameChange}
                isRequired={true}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.authorization.lastname}
                textInput={lastname}
                handleTextInputChange={handleLastnameChange}
                isRequired={true}
              />
            </div>
            <div>
              <EmailInput
                inputTitle={compte.authorization.email}
                emailInput={email}
                handleEmailInputChange={handleEmailChange}
              />
            </div>
            <div>
              <IntInput
                inputTitle={compte.authorization.postalcode}
                intInput={postalcode}
                handleIntInputChange={handlePostalcodeChange}
                isRequired={true}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.authorization.comment}
                textInput={comment}
                handleTextInputChange={handleCommentChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <CreateButton buttonDisabled={buttonDisabled} handleSubmit={handleSubmit} />
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}></GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default AddAuthorizationDialog;
